import { useState, type FormEvent } from 'react'
import { errorMessage } from '../api/client'
import { Note } from '../components/ui'
import { ShopLockup } from '../components/FlowerMark'
import { useAuth } from './AuthContext'

export function Login() {
  const { signIn } = useAuth()
  const [username, setUsername] = useState('uzair')
  const [pin, setPin] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await signIn(username, pin)
    } catch (err) {
      setError(errorMessage(err))
      setPin('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__plate">
          <h1 className="login__title">
            <ShopLockup width={210} />
          </h1>
        </div>
        <p className="login__sub">حساب کھولنے کے لیے پن لکھیں</p>

        {error && <Note kind="error">{error}</Note>}

        <div className="field">
          <label>نام</label>
          <input
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
          />
        </div>

        <div className="field">
          <label>پن</label>
          <input
            type="password"
            inputMode="numeric"
            value={pin}
            maxLength={10}
            onChange={(event) => setPin(event.target.value.replace(/\D/g, ''))}
            autoComplete="current-password"
          />
        </div>

        <button className="btn" style={{ width: '100%' }} disabled={busy || pin.length < 4}>
          {busy ? 'کھل رہا ہے…' : 'کھولیں'}
        </button>
      </form>
    </div>
  )
}
